import { ApiSettings, AppSettings } from "application/index";
import StorageService from "infrastructure/common/storage";

const downloadDocuments = (email, rut) => {
  const token = StorageService.getItem(AppSettings.ticketName);
  window.open(
    `${ApiSettings.downloadUnSignedDocs}?username=${email}&ticket=${token}&rut=${rut}`,
    "_blank"
  );
};

export default downloadDocuments;
